import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Link } from 'react-router-dom';

import Campaigns from '../campaigns/Campaigns';
import Archive from '../campaigns/archive/Archive';

import CampaignPage from '../campaign/Campaign';
import StatsPage from '../campaign/stats/Stats';

import { withLocalize, Translate } from "react-localize-redux";
var campaignTranslations = require("../../translations/campaign.json")

class CampaignsRouter extends React.Component<any, any> {
  constructor(props:any) {
    super(props)
    this.props.addTranslation(campaignTranslations)
  }
  public render() {
    return (
      <div id="tasks-router-root">
        <div className="buttonsHeader">
          {window.account.type == "admin" && <Link to="/campaigns/new"><button><Translate id="campaign.newCampaign" /></button></Link>}
          <Link to="/campaigns/archive"><button><Translate id="campaign.archive"/></button></Link>
        </div>

        <Switch>
          <Route exact path={`/campaigns`} component={Campaigns} />
          <Route exact path={`/campaigns/new`} component={CampaignPage} />
          <Route exact path={`/campaigns/archive`} component={Archive} />

          <Route exact path={`/campaigns/:id`} component={CampaignPage} />
          <Route exact path={`/campaigns/:id/stats`} component={StatsPage} />

        </Switch>

      </div>
    );
  }
}

export default withLocalize(CampaignsRouter)



// WEBPACK FOOTER //
// ./src/pages/home/CampaignsRouter.tsx